import { FC, PropsWithChildren } from 'react';

import './index.scss';

const Main: FC<PropsWithChildren> = ({ children }) => {
  return <div className="legal-page__main paragraph--s">{children}</div>;
};

export default Main;
